const ScanStats = ({ items }) => (
  <div className="warehouse-stats">
    {items.map((item) => (
      <div key={item.label} className={`warehouse-stat border-${item.variant}`}>
        <div className={`warehouse-stat__value text-${item.variant}`}>{item.value}</div>
        <div className="warehouse-stat__label">{item.label}</div>
      </div>
    ))}
  </div>
);

export default ScanStats;
